import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { SYSTEM_ALLOWED_DATA_SOURCES } from './dataSourcePolicy.js';
import { AI_USAGE_LOG, AI_USAGE_ROLLUP, } from '../types/ai.js';
export const aiUsageLogDescriptor = {
    name: AI_USAGE_LOG,
    label: 'Registro de uso de IA',
    domain: 'ai',
    collectionPath: 'org/{orgId}/aiUsageLog',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Immutable per-request AI usage log entry',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'organizationId', label: 'Organização', type: 'string', required: true },
        { name: 'userId', label: 'Usuário', type: 'string', required: true },
        { name: 'provider', label: 'Provedor', type: 'string', required: true },
        { name: 'model', label: 'Modelo', type: 'string', required: true },
        { name: 'usePoint', label: 'Ponto de uso', type: 'string', required: true },
        { name: 'inputTokens', label: 'Tokens de entrada', type: 'number', required: true },
        { name: 'outputTokens', label: 'Tokens de saída', type: 'number', required: true },
        {
            name: 'cachedInputTokens',
            label: 'Tokens de entrada em cache',
            type: 'number',
            required: false,
        },
        { name: 'totalTokens', label: 'Total de tokens', type: 'number', required: true },
        { name: 'costUsd', label: 'Custo (USD)', type: 'number', required: true },
        {
            name: 'startsQuestion',
            label: 'Inicia pergunta',
            type: 'boolean',
            required: false,
            description: 'True when this round opens a user question. Absent on older logs; treat missing as false',
        },
        { name: 'ts', label: 'Data/hora', type: 'date', required: true },
    ],
};
export const aiUsageRollupDescriptor = {
    name: AI_USAGE_ROLLUP,
    label: 'Consolidado de uso de IA',
    domain: 'ai',
    collectionPath: 'org/{orgId}/aiUsage',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Monthly AI usage rollup per organization (document id: yyyy-mm)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'organizationId', label: 'Organização', type: 'string', required: true },
        { name: 'requests', label: 'Requisições', type: 'number', required: true },
        {
            name: 'tokens',
            label: 'Tokens de IA',
            type: 'number',
            required: false,
            description: 'System billing tokens (not provider counts). Absent on months before token metering; treat missing as 0',
        },
        { name: 'inputTokens', label: 'Tokens de entrada', type: 'number', required: true },
        { name: 'outputTokens', label: 'Tokens de saída', type: 'number', required: true },
        {
            name: 'cachedInputTokens',
            label: 'Tokens de entrada em cache',
            type: 'number',
            required: false,
            description: 'Absent on months before cache metering; treat missing as 0',
        },
        { name: 'totalTokens', label: 'Total de tokens', type: 'number', required: true },
        { name: 'costUsd', label: 'Custo (USD)', type: 'number', required: true },
        {
            name: 'byProvider',
            label: 'Por provedor',
            type: 'object',
            required: false,
            description: 'Per-provider usage slice (requests, tokens, costUsd)',
        },
        {
            name: 'byUsePoint',
            label: 'Por ponto de uso',
            type: 'object',
            required: false,
            description: 'Per use-point usage slice (requests, tokens, costUsd)',
        },
        {
            name: 'byUser',
            label: 'Por usuário',
            type: 'object',
            required: false,
            description: 'Per-user usage slice. Absent on months before byUser metering — treat missing as {}; do not backfill from aiUsageLog',
        },
    ],
};
//# sourceMappingURL=ai.descriptor.js.map